import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7250f5a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo Projeto", -1))
const _hoisted_3 = { class: "table is-fullwidth" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Nome"),
    /*#__PURE__*/_createElementVNode("th", null, "Ações")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" })
], -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_router_link, {
      to: "/projetos/novo",
      class: "button"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (projeto) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: projeto.id
          }, [
            _createElementVNode("td", null, _toDisplayString(projeto.id), 1),
            _createElementVNode("td", null, _toDisplayString(projeto.name), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: `/projetos/${projeto.id}`,
                class: "button"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("button", {
                class: "button ml-2 is-danger",
                onClick: ($event: any) => (_ctx.excluir(projeto.id))
              }, _hoisted_8, 8, _hoisted_6)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}